import { tokenAliasOrValue } from "./base";
import { z } from "zod";
export const FontFamilyValue = z.string();
export const FontFamilyTokenData = tokenAliasOrValue(FontFamilyValue);
